import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/reports/findOrCreateBulkGroupCode`;

export const ROUTE: RouteDefinition = `${baseRoute}/reports/findOrCreateBulkGroupCode`;

export const URL = (): RouteDefinition => `${baseRoute}/reports/findOrCreateBulkGroupCode`;
